// import http from '../../../api/http'
// import help from '../../../util/help'
import user from "../../../api/user";
// import md5 from 'js-md5'
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      loginName: "",
      loginPass: "",
      msg: "",
    };
  },
  computed: {
    ...mapGetters({
      loading: "getLoading",
      user: "getUser",
    }),
  },
  mounted() {
    // setTimeout(help.drawBackground('particle-canvas'), 0)
    this.updateLoading(false);
    this.tokenLogin();

    document.onkeyup = (e) => {
      // 兼容FF和IE和Opera
      var event = e || window.event;
      var key = event.which || event.keyCode || event.charCode;
      if (key == 13 && this.$route.path === "/access/login") {
        this.login();
      }
    };
  },
  methods: {
    ...mapActions(["updateLoading", "updateUser"]),
    login() {
      // this.updateLoading(true)
      const { loginName, loginPass } = this;
      if (loginName === "jofphadmin" && loginPass === "Lambic!@") {
        localStorage.setItem(
          "token",
          "Bearer eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiI2MDM0NjVlYjAxM2JhNDAzM2RjY2ZmMGMiLCJzdWIiOiJ7XCJpcFwiOlwiMTI3LjAuMC4xXCIsXCJ1c2VySWRcIjowLFwidXNlcm5hbWVcIjpcInN2XCJ9IiwiaXNzIjoiSU1SLVVTRVIiLCJpYXQiOjE2MTQwNDY2OTksImV4cCI6NDc2NzY0NjY5OX0.HdUPIgpl4MHI9y9AEX-Sdf5n0G88fFN2kZXhtg4HDkw"
        );
        this.$router.push("/jofph/workbench");
        this.updateUser({ nickname: "admin" });
      } else {
        this.$message.error("账号密码错误！");
      }
      // const hash = md5(loginPass + 'ck');

      // 跳过登陆
      // this.$router.push('/workbench')
      // this.updateLoading(false)

      // 正常登陆
      // const formData = new FormData()
      // formData.append('username', loginName)
      // formData.append('password', loginPass)
      // http.login(formData).then(res => {
      //   this.updateLoading(false)
      //   if (res && res.loginSuccess) {
      //     // if (res.type === 1) {
      //     localStorage.setItem('user', JSON.stringify(res.userInfo))
      //     this.updateUser(res.userInfo)
      //     this.$router.push('/workbench')
      //     // } else {
      //     //   this.msg = '账号权限不足！'
      //     // }
      //   } else if (res && res.errorMsg) {
      //     this.msg = res.errorMsg
      //   }
      // })
    },
    tokenLogin() {
      if (!localStorage.getItem("token")) {
        return;
      }
      user.getUserInfo().then((res) => {
        if (res) {
          localStorage.setItem("user", JSON.stringify(res));
          this.updateUser(res);
          this.$router.push("/workbench");
        }
      });
    },
  },
};
